import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { MessageResponse } from '../_models/responses';

export interface Breach {
  id?: number;
  description: string;
  firstname: string;
  lastname: string;
  middlename?: string;
  datereported: string;
  createdBy: string;
  unit_number: number;
  title: string;
  propertyId: number;
  bylawid?: number;
  status: string;
}

@Injectable({ providedIn: 'root' })
export class BreachService {
  constructor(private http: HttpClient) {}

  getBreachesByPropertyId(propertyId: number) {
    return this.http.get<Breach[]>(`${environment.apiUrl}/api/breach/property/${propertyId}`);
  }

  getBreachesByPropertyIdAndUnitNumber(propertyId: number, unitNumber: number) {
    return this.http.get<Breach[]>(`${environment.apiUrl}/api/breach/property/${propertyId}/unit/${unitNumber}`);
  }

  getBreach(breachId: number) {
    return this.http.get<Breach>(`${environment.apiUrl}/api/breach/${breachId}`);
  }

  createBreach(request: any) {
    let header = new HttpHeaders();
    header = header.append('content-type', 'application/json');

    return this.http.post<MessageResponse>(`${environment.apiUrl}/api/breach`, request, { headers: header });
  }

  updateBreach(breachId: number, request: any) {
    return this.http.put<MessageResponse>(`${environment.apiUrl}/api/breach/${breachId}`, request);
  }

  deleteBreach(breachId: number) {
    return this.http.delete<MessageResponse>(`${environment.apiUrl}/api/breach/${breachId}`);
  }
}
